import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { HomeComponent } from './home/home.component';
// import { CheckAvailabilityComponent } from '../check-availability/check-availability.component'
import { AddressNotAvailableComponent } from './address-not-available/address-not-available.component';
import { FullyQaulifiedAddressComponent } from './fully-qaulified-address/fully-qaulified-address.component';
import { HomeMsiteComponent } from './home-msite/home-msite.component';
import { ResetMobComponent } from './reset-mob/reset-mob.component';
import { EnrollComponent } from './enroll/enroll.component';

const routes: Routes = [
  // { path: '', component: HomeComponent },
  // { path: 'enroll', component: HomeComponent },
  // { path: '', component: CheckAvailabilityComponent },
  // { path: 'enroll', component: CheckAvailabilityComponent },
  { path: 'enroll-embed', component: HomeMsiteComponent },
  { path: 'service-not-available', component: AddressNotAvailableComponent },
  { path: 'location-not-sure', component: FullyQaulifiedAddressComponent },
  { path: 'reset/user/:mobile', component: ResetMobComponent },
  { path: 'enroll-demo', component: EnrollComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared-routing.module.ts